if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.featured = this.dataset.featured;
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.toggleCheckoutButton(true, '', false)
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.toggleCheckoutButton(true, '', true)
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (!this.featured) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let productSlider = document.querySelector('.thb-product-detail .product-images'),
        thumbnails = document.querySelector('.thb-product-detail #Product-Thumbnails');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      var hide_variants = productSlider.dataset.hideVariants == 'true',
        flkty = Flickity.data(productSlider),
        images = productSlider.querySelectorAll('.product-images__slide');

      if (flkty && hide_variants) {
        [].forEach.call(images, function(el) {
          el.classList.remove('is-selected');
        });
        productSlider.querySelector(mediaId).classList.add('is-selected');
        productSlider.reInit();
        productSlider.selectCell(mediaId);

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          thumbnails.prepend(activeThumb);
        }
      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      // return [`cupon-off-price`,`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`, `price-noAddon-${this.dataset.section}`, `variant-main-img-change-handle-1`, `variant-main-img-change-handle-2`, `variant-main-img-change-handle-3`, `variant-main-img-change-handle-4`, `variant-main-img-change-handle`, `bundle-other-img-change-1`, `bundle-other-img-change-2`, `bundle-other-img-change-3`, `bundle-other-img-change-4`, `bundle-other-img-change`, `bundle-price-change-1`, `bundle-price-change-2`, `bundle-price-change-3`, `bundle-price-change-4`, `bundle-price-change-5`];
      return [`variant-bgimg`,`cupon-off-price`,`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`, `price-noAddon-${this.dataset.section}`, `bundle-fieldset`, `coupon-off-change`, `free-gift-inputs`, `variant-diff-free_gift`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          this.toggleCheckoutButton(!this.currentVariant.available)
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      });

      if (!modifyClass) return;
    }
    toggleCheckoutButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const submitButton = document.getElementById('direct-checkout');

      if (!submitButton) return;

      if (disable) {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.classList.add('unavailable')
      } else {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('unavailable')
        submitButton.classList.remove('loading');
      }

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index+1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      const product_container = this.closest('.thb-product-detail');
      const thumbnail_container = product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide',
        cellAlign:window.innerWidth > 768 ? 'left' : 'center',
        autoPlay:false,
        // pauseAutoPlayOnHover: true
      };

      if (this.hide_variants) {
        this.options.cellSelector = '.product-images__slide, .product-images__slide-item--variant.is-selected';
      }

      // Start Slider
      this.init();
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;
      this.currentSlideIndex = this.flkty.selectedIndex;
      this.slideStartTime = Date.now(); // 进页面瞬间，开始给第一张图计时
      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
      // 追踪初始图片
      this.trackSlideView(this.selectedIndex);
    }
    reInit() {
      this.flkty.destroy();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        this.prev_button.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        this.prev_button.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        this.next_button.addEventListener('click', (event) => {
          this.flkty.next();
        });
        this.next_button.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function() {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function(index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          slide = this.flkty.cells[index].element,
          media = slide.querySelector('.product-single__media'),
          active_thumb = this.thumbnails[index];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');
        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: 0,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });
        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }
        // 追踪当前图片浏览
        const now = Date.now();
        const duration = now - this.slideStartTime;
        this.trackSlideView(this.currentSlideIndex, duration);
        this.currentSlideIndex = index;
        this.slideStartTime = now;
      });

      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
          this.thumbnailClick(thumbnail, index);
        });
      });
    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function(el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide .product-single__media-image, .product-images__slide-item--variant.is-selected .product-single__media-image'));
      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function() {
          pswp.listen('parseVerticalMargin', function(item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
    trackSlideView(index, duration) {
      try {
        // 确保 dataLayer 存在
        window.dataLayer = window.dataLayer || [];
        
        // 获取当前 slide 元素
        const slide = this.flkty.cells[index]?.element;
        if (!slide) return;
        
        const media = slide.querySelector('.product-single__media');
        if (!media) return;
        
        // 判断媒体类型
        let imageType = 'image';
        let imageSrc = '';
        
        if (media.classList.contains('product-single__media-image')) {
          imageType = 'image';
          const img = media.querySelector('img');
          imageSrc = img ? img.src ? new URL(img.src).pathname : img.src : '';
        } else if (media.classList.contains('product-single__media-external-video') || 
                  media.classList.contains('product-single__media-native-video')) {
          imageType = 'video';
          const iframe = media.querySelector('iframe');
          const video = media.querySelector('video');
          imageSrc = iframe ? iframe.src : (video ? video.src : '');
        }
        
        // 推送事件到 dataLayer
        // window.dataLayer.push({
        //   event: 'product_image_view',
        //   image_type: imageType,
        //   image_src: imageSrc,
        //   image_index: index + 1  // 从1开始计数，便于阅读
        // });
        
        // 只有停留超过 0.5 秒才记录，排除快速扫视
        if (duration > 500 && typeof gtag !== 'undefined') {
            gtag('event', 'slide_dwell_time', {
                'slide_index': index + 1,        // 转换成 1, 2, 3...
                'duration_ms': duration,
                'image_src': imageSrc,
                // 【重要】设置 transport 为 beacon，确保在页面关闭时数据也能发出去
                'transport_type': 'beacon' 
            });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
      // this.newCheckoutBtn = document.getElementById('direct-checkout')
      this.newCheckoutBtn = document.querySelectorAll('.direct-checkout')
      if(this.newCheckoutBtn.length) {
        this.newCheckoutBtn.forEach(btn => {
          btn.classList.remove('.add-to-cart-pointer')
          btn.addEventListener('click', this.onCheckoutDirect.bind(this))
        })
      }
      // if(this.dataset.showSummary) {
      //   document.addEventListener('add-ons:update', this.calcSummary.bind(this))
      // }
    }
    calcSummary(evt) {
      let summaryContainer = document.querySelector('.selection-summary-container')
      if(evt.detail.totalCount > 0) {
        this.classList.add('show-select-summary')
        let optionHtml = ''
        evt.detail.items.forEach((item, i) => {
          optionHtml += i === 0 ? `
            <div class="selection-summary-option main">
              <div class="selection-prod-img"><img src="${item.featuredImage}" alt=""></div>
              <div class="selection-prod-title main">
                <div class="main-prod-option">
                  <span class="main-prod-option-title option-title-con">${item.title}</span>
                  <span class="main-selected-variant">
                    <span>$${item.price / 100}</span>
                    <span>${item.variantTitle}</span>
                  </span>
                </div>
                <div>x${item.quantity}</div>
              </div>
            </div>` : `
            <div class="selection-summary-option">
              <div class="selection-prod-img"></div>
              <div class="selection-prod-title">
                <span class="option-title-con">${item.title}</span>
                <span>x1</span>
              </div>
            </div>`;
        })
        let html = `
            <div class="selection-summary-title">Selection Summary</div>
            <div class="selection-summary-content">${optionHtml}</div>
            <div class="selection-summary-price">
              <div class="selection-price-con">
                <span class="selection-price">$${evt.detail.totalPrice / 100}</span>
                <span class="selection-compare-price">${evt.detail.totalComparePrice > evt.detail.totalPrice ? `$${evt.detail.totalComparePrice / 100}` : ''}</span>
                ${evt.detail.totalComparePrice > evt.detail.totalPrice ? `<span class="selection-save">Save $${evt.detail.save / 100}</span>` : ''}
              </div>
            </div>
        `
        summaryContainer.innerHTML = html

      }else {
        this.classList.remove('show-select-summary')
        summaryContainer.innerHTML = ''
      }
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      // 把主商品也转成 items[] 格式
      const mainVariantId = formData.get('id');
      const mainQuantity = formData.get('quantity') || 1;

      const fbtCheckboxes = document.querySelectorAll('.poi-checkbox');

      if (fbtCheckboxes.length && [...fbtCheckboxes].some(cb => cb.checked)) {
        // 有赠品，统一用 items[] 格式
        formData.delete('id');
        formData.delete('quantity');
        
        // 主商品
        formData.append('items[][id]', mainVariantId);
        formData.append('items[][quantity]', mainQuantity);

        // 赠品
        fbtCheckboxes.forEach(cb => {
          if (cb.checked) {
            formData.append('items[][id]', cb.dataset.variantId);
            formData.append('items[][quantity]', 1);
            formData.append('items[][properties][_MainProductVariantId]', mainVariantId);
            if (cb.dataset.free) {
              formData.append('items[][properties][_freeProduct]', mainVariantId);
            }
          }
        });
      }

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }
          // ==========================================
          // 【数据追踪区】仅在带有赠品加购时触发，手动剥离并只推送主产品
          // ==========================================
          try {
            // 判断是否有 items 数组 (只有走了带有赠品的逻辑，Shopify 才会返回 items 数组)
            if (response.hasOwnProperty('items') && response.items.length > 1) {
              
              // 核心过滤逻辑：找出没有 _freeProduct 属性的商品（即主产品）
              // 如果因为某种奇葩原因找不到，兜底使用数组的第 0 项（我们最先 append 的主品）
              const mainItem = response.items.find(item => !(item.properties && item.properties._MainProductVariantId)) || response.items[0];
              const trackedQuantity = parseInt(mainQuantity, 10) || 1;
              if (typeof window.gtag === 'function') {
                window.gtag('event', 'add_to_cart', {
                  currency: window.Shopify?.currency?.active || 'USD',
                  value: ((mainItem.price || 0) / 100) * trackedQuantity, // 仅计算主产品价值
                  items: [{
                    item_id: String(mainItem.variant_id || mainItem.id),
                    item_name: mainItem.product_title || mainItem.title,
                    price: (mainItem.price || 0) / 100,
                    quantity: trackedQuantity
                  }]
                });
              }
            }
          } catch (analyticsError) {
            console.warn('Analytics tracking error caught (Silenced):', analyticsError);
          }
          // ==========================================
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
          document.getElementById('Cart-Drawer').focus()
        }
      } else if (document.getElementById('Cart-Drawer')) {
        this.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        document.getElementById('Cart-Drawer').focus()
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    async onCheckoutDirect(evt) {
      evt.preventDefault();
      let formData = new FormData(this.form);
      let mainId = formData.get('id')
      const metafieldScript = document.getElementById('ProductMetafieldData');
      const fbtProducts = metafieldScript ? JSON.parse(metafieldScript.textContent) : {};
      const fbtCheckboxes = Array.from(document.querySelectorAll('.poi-checkbox'));
      const addOnsCheckboxs = Array.from(document.querySelectorAll('.add-on-container .poi-checkbox'));
      let addOnscheckedFbt = addOnsCheckboxs.filter(cb => cb.checked);
      let checkedFbt = fbtCheckboxes.filter(cb => cb.checked)
      let checkedId = checkedFbt.map(item=>item.dataset.productId)
      fbtProducts.items = checkedFbt.map(cb => ({
        id: cb.dataset.variantId,
        quantity: 1,
        properties: {
          _MainProductVariantId: mainId,
          // 根据条件动态添加属性
          ...(cb.dataset.free && { _freeProduct: mainId }),
        },
      }))
      fbtProducts.items.push({
        id: formData.get('id'),
        quantity: formData.get('quantity')
      })
      if(fbtProducts.cartMetaProduct) {
        fbtProducts.cartMetaProduct = fbtProducts.cartMetaProduct.filter(item=>!checkedId.includes(String(item.id)))
      }
      if(fbtProducts.cartMetaProduct?.length>0&&window.openRecModal&&addOnscheckedFbt.length===0&&false) {
        window.openRecModal(fbtProducts)
      }else {
        this.newCheckoutBtn.forEach(item=>item.classList.add('loading'))
        try {
          // // 1. 先清空购物车
          // await fetch('/cart/clear.js', { method: 'POST' });
          // await fetch('/cart/add.js', {
          //   method: 'post',
          //   headers: { 'Content-Type': 'application/json' },
          //   body: JSON.stringify({ items: fbtProducts.items })
          // })
          // this.newCheckoutBtn.forEach(item=>item.classList.remove('loading'))

          // // 3. 跳转到结账
          // window.location.href = '/checkout';

          // storefront api
          const checkoutUrl = await this.createCartAndRedirect(fbtProducts.items);
          
          this.newCheckoutBtn.forEach(item => item.classList.remove('loading'));
          window.location.href = checkoutUrl;
          
        } catch (error) {
          // 构建购物车链接
          // const cartItems = fbtProducts.items.map(p => `${p.id}:${p.quantity}`).join(',');
          // const checkoutUrl = `/cart/${cartItems}`;
          // this.newCheckoutBtn.forEach(item=>item.classList.remove('loading'))
          // // 跳转到结账
          // window.location.href = checkoutUrl;
          // console.error('操作失败:', error);
            console.error('Checkout 创建失败，fallback 到 permalink:', error);
  
          // Fallback：用 permalink（丢失 properties 但能结账）
          const cartItems = fbtProducts.items
            .map(p => `${p.id}:${p.quantity}`)
            .join(',');
          
          this.newCheckoutBtn.forEach(item => item.classList.remove('loading'));
          window.location.href = `/cart/${cartItems}`;
        }
      }
    }
    async createCartAndRedirect(items) {
      items.forEach(item => {
        console.log(btoa(`gid://shopify/ProductVariant/${item.id}`))
      })
      const lines = items.map(item => ({
        merchandiseId: `gid://shopify/ProductVariant/${item.id}`,
        quantity: parseInt(item.quantity) || 1,
        attributes: Object.entries(item.properties || {}).map(([key, value]) => ({
          key,
          value: String(value)
        }))
      }));

      const mutation = `
        mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              checkoutUrl
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      const response = await fetch(
        'https://urevoca.myshopify.com/api/2025-10/graphql.json',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '96cd70a38c121a43f5e44b3e808aa0bc'
          },
          body: JSON.stringify({
            query: mutation,
            variables: { input: { lines } }
          })
        }
      );

      const { data, errors } = await response.json();

      if (errors || data.cartCreate.userErrors.length > 0) {
        throw new Error(JSON.stringify(errors || data.cartCreate.userErrors));
      }

      return data.cartCreate.cart.checkoutUrl;
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;
    }
    connectedCallback() {

      this.setupObservers();
      this.setupToggle();
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }
    setupToggle() {
      const button = this.querySelector('.add_to_cart_btn'),
      content = this.querySelector('.product-add-to-cart-sticky--content');
      if(!button) return
      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        // tl
        //   .set(content, {
        //     display: 'block',
        //     height: 'auto'
        //   }, 'start')
        //   .from(content, {
        //     height: 0,
        //     duration: 0.25
        //   }, 'start+=0.001');
        // button.addEventListener('click', function() {
        //   if(tl.reversed()){
        //     document.querySelector(".add_to_cart_btn").style.opacity = 0;
        //     tl.play();
        //   }else{
        //     document.querySelector(".add_to_cart_btn").style.opacity = 1;
        //     tl.reverse();
        //   }
        //   return false;
        // });
        
        button.addEventListener('click',this.addToCart.bind(this))

      } else {
        button.addEventListener('click', function() {
          content.classList.toggle('active');
          return false;
        });
      }

    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function(entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              // 滚动至不可见
              // let boundingRect = form.getBoundingClientRect();
              // if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
              //   _this.formPassed = true;
              //   _this.classList.add('sticky--visible');
              // } else if (entry.intersectionRatio === 1) {
              //   _this.formPassed = false;
              //   _this.classList.remove('sticky--visible');
              // }
              // 只要不可见即可
                // 只要表单完全不可见，就显示粘性元素
              // if (entry.intersectionRatio === 0) {
              //   _this.formPassed = true;
              //   _this.classList.add('sticky--visible');
              // } else {
              //   _this.formPassed = false;
              //   _this.classList.remove('sticky--visible');
              // }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }

    setEventListeners() {
      this.button.addEventListener('click', this.addToCart.bind(this));
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    addToCart() {
      this.button.classList.add('loading');
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      var input = document.querySelector('input[name="id"]');  
      this.id = input.value;

      let formData = new FormData(this.form);
      formData.append('id', this.id);
      formData.append('quantity', 1);

      // 把主商品也转成 items[] 格式
      const mainVariantId = formData.get('id');
      const mainQuantity = formData.get('quantity') || 1;

      const fbtCheckboxes = document.querySelectorAll('.poi-checkbox');

      if (fbtCheckboxes.length && [...fbtCheckboxes].some(cb => cb.checked)) {
        // 有赠品，统一用 items[] 格式
        formData.delete('id');
        formData.delete('quantity');
        
        // 主商品
        formData.append('items[][id]', mainVariantId);
        formData.append('items[][quantity]', mainQuantity);

        // 赠品
        fbtCheckboxes.forEach(cb => {
          if (cb.checked) {
            formData.append('items[][id]', cb.dataset.variantId);
            formData.append('items[][quantity]', 1);
            formData.append('items[][properties][_MainProductVariantId]', mainVariantId);
            if (cb.dataset.free) {
              formData.append('items[][properties][_freeProduct]', mainVariantId);
            }
          }
        });
      }

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          // ==========================================
          // 【数据追踪区】仅在带有赠品加购时触发，手动剥离并只推送主产品
          // ==========================================
          try {
            // 判断是否有 items 数组 (只有走了带有赠品的逻辑，Shopify 才会返回 items 数组)
            if (response.hasOwnProperty('items') && response.items.length > 1) {
              
              // 核心过滤逻辑：找出没有 _freeProduct 属性的商品（即主产品）
              // 如果因为某种奇葩原因找不到，兜底使用数组的第 0 项（我们最先 append 的主品）
              const mainItem = response.items.find(item => !(item.properties && item.properties._MainProductVariantId)) || response.items[0];
              const trackedQuantity = parseInt(mainQuantity, 10) || 1;
              if (typeof window.gtag === 'function') {
                window.gtag('event', 'add_to_cart', {
                  currency: window.Shopify?.currency?.active || 'USD',
                  value: ((mainItem.price || 0) / 100) * trackedQuantity, // 仅计算主产品价值
                  items: [{
                    item_id: String(mainItem.variant_id || mainItem.id),
                    item_name: mainItem.product_title || mainItem.title,
                    price: (mainItem.price || 0) / 100,
                    quantity: trackedQuantity
                  }]
                });
              }
            }
          } catch (analyticsError) {
            console.warn('Analytics tracking error caught (Silenced):', analyticsError);
          }
          // ==========================================
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        });
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));
      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        document.getElementById('Cart-Drawer').focus()
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }  

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if(!customElements.get('product-sticky-header')) {
  class ProductStickyHeader extends HTMLElement {
    constructor() {
      super();
      // 初始化滚动状态
      this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // 绑定防抖后的处理函数
      this.handleScroll = this.debounce(this._handleScroll.bind(this));
      this.config = {
        debounceTime: 100,
        scrollDelta: 50,
        directionThreshold: 5
      };
    }
    connectedCallback() {
      setTimeout(() => {
        this.setupObservers();
        // window.addEventListener('scroll', this.handleScroll, { passive: true });
      }, 0);
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function(entries) {
          entries.forEach((entry) => {
            if (entry.target === title) {
              let boundingRect = title.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky_header--visible');
                _this.style.height = pageHeader.clientHeight + 'px'
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky_header--visible');
                _this.style.height = 0
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        pageHeader = document.querySelector('.header-section'),
        productMain = document.querySelector('.product-grid-container'),
        title = document.querySelector('.product-title');
        _this.formPassed = false;
        observer.observe(form);
        observer.observe(title);
        observer.observe(productMain);
    }
    debounce(func) {
      let timeout;
      const wrapper = (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), this.config.debounceTime);
      };
      
      // 添加取消方法
      wrapper.cancel = () => clearTimeout(timeout);
      return wrapper;
    }
    // 核心处理逻辑
    _handleScroll() {
      
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      const delta = currentScroll - this.lastScrollTop;

      // 过滤微小滚动
      if (Math.abs(delta) < this.config.directionThreshold) return;

      // 处理有效滚动
      if (Math.abs(delta) >= this.config.scrollDelta) {
        this._dispatchDirection(delta);
        this._updateScrollPosition(currentScroll, delta);
      }

      // 更新最后记录位置（即使未触发事件也要更新）
      this.lastScrollTop = currentScroll;
    }
    // 触发滚动方向事件
    _dispatchDirection(delta) {
      const direction = delta > 0 ? 'down' : 'up';
      // console.log(`有效滚动方向：${direction}`);
      if(delta > 0) {
        this.classList.remove('scroll-hidden')
      }else {
        this.classList.add('scroll-hidden')
      }
      // 可扩展为自定义事件
      // const event = new CustomEvent('scroll-direction', {
      //   detail: { direction, delta }
      // });
      // window.dispatchEvent(event);
    }
    // 安全更新滚动位置
    _updateScrollPosition(currentScroll, delta) {
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      this.lastScrollTop = delta > 0 
        ? Math.min(currentScroll, maxScroll)
        : Math.max(currentScroll, 0);
    }
  }

  customElements.define('product-sticky-header', ProductStickyHeader);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (!customElements.get('accordion-block')) {
  class AccordionBlock extends HTMLElement {
    constructor() {
        super();
        this.isOpen = false;
        this.button = this.querySelector('[data-accordion-trigger]');
        this.content = this.querySelector('[data-accordion-content]');
        this.icon = this.querySelector('[data-accordion-icon]');
        this.label = this.querySelector('[data-accordion-label]');
        
        // 初始化状态，默认可能是展开或收起的
        this.isOpen = this.hasAttribute('open');
        this.updateUI();
    }

    connectedCallback() {
        if (this.button) {
        this.button.addEventListener('click', this.toggle.bind(this));
        }
    }

    toggle() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            this.setAttribute('open', '');
        } else {
            this.removeAttribute('open');
        }
        this.updateUI();
    }

    updateUI() {
        // 1. 处理高度动画 (使用 Grid trick)
        // 注意：CSS 会处理 transition，这里主要负责触发类名或属性
        
        // 2. 切换文字 (Show Less / Show More)
        if (this.label) {
            this.label.textContent = this.isOpen ? 'Show Less' : 'Show More';
        }

        // 3. 旋转图标
        if (this.icon) {
            this.icon.style.transform = this.isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
        }
    }
  }
  customElements.define('accordion-block', AccordionBlock);
}
/* ==================================================
   Comparison Modal Logic
   ================================================== */
(function(){
  // 定义主逻辑类
  class ProductCompareModal {
    constructor(container) {
      this.container = container;
      this.jsonScript = container.querySelector('#CompareDataJSON');
      
      // 如果没有数据源，停止执行
      if (!this.jsonScript) return;

      // 1. 读取数据
      const rawData = JSON.parse(this.jsonScript.textContent);
      this.allProducts = rawData.products;
      this.currentId = rawData.currentId; // 当前详情页的产品ID
      
      // 2. 初始化状态
      this.filterProducts = [];
      this.selectors = Array.from(container.querySelectorAll('custom-select-new'));
      this.specKeys = ['weight_capacity','speed','incline','size','horsepower','handrail','material','control_method','folded_size','unfolded_size','weight','recommend','warranty'];

      // 3. 启动
      this.init();
      this.bindEvents();
    }

    init() {
      // 逻辑：确保当前产品在第一个位置 (Index 0)
      const currentPrdObj = this.allProducts.find(p => p.id == this.currentId);
      
      if (currentPrdObj) {
        // 过滤掉当前产品，取剩下的前两个作为对比
        const others = this.allProducts.filter(p => p.id != this.currentId).slice(0, 1);
        this.filterProducts = [currentPrdObj, ...others];
      } else {
        // 如果当前产品不在对比集合里，就取前三个
        this.filterProducts = this.allProducts.slice(0, 2);
      }

      // 准备下拉框的 Options 数据
      const options = this.allProducts.map(item => ({
        value: item.id,
        label: item.metafields ? item.metafields.product_title : item.title,
        // series:item.metafields ? item.metafields.series : '',
        // price: item.price
      }));

      // 初始化下拉框
      this.selectors.forEach((select, index) => {
        // 调用 web component 的方法
        if (select.setOptions) {
          select.setOptions(options);
          
          // 设置当前选中的值 (防越界)
          if(this.filterProducts[index]) {
              select.setValue(this.filterProducts[index].id);
          }
        }
      });

      // 初次渲染
      this.renderAll();
    }

    bindEvents() {
      // 下拉框切换事件 (利用事件委托或直接绑定)
      this.selectors.forEach((select) => {
        select.addEventListener('change', (e) => this.handleSelectChange(e, select));
      });

      // 关闭按钮
      const closeBtn = this.container.querySelector('.close-compare-modal');
      const overlay = this.container.querySelector('.compare-modal-overlay');
      
      const closeFn = () => {
          this.container.classList.remove('is-active');
          document.body.style.overflow = ''; // 恢复滚动
      };

      if(closeBtn) closeBtn.addEventListener('click', closeFn);
      if(overlay) overlay.addEventListener('click', closeFn);
    }

    handleSelectChange(e, changedSelect) {
      const newValue = e.detail.value;
      const index = this.selectors.indexOf(changedSelect);
      const newProduct = this.allProducts.find(p => p.id == newValue);

      // 检查是否重复：如果选了已经存在的，就交换位置
      const existingIndex = this.filterProducts.findIndex(p => p && p.id == newValue);

      if (existingIndex !== -1 && existingIndex !== index) {
        // 交换逻辑
        // 1. 把原来位置的产品换成我们要被替换掉的产品
        // 比如 A, B, C。把 B 换成 A。 -> A(old B), A(new), C -> 交换后 -> B, A, C
        const productToBeReplaced = this.filterProducts[index];
        
        this.filterProducts[existingIndex] = productToBeReplaced;
        this.filterProducts[index] = newProduct;

        // 更新那个被动交换的下拉框 UI
        this.selectors[existingIndex].setValue(productToBeReplaced.id);
        
      } else {
        // 正常替换
        this.filterProducts[index] = newProduct;
      }

      this.renderAll();
    }

    renderAll() {
      this.renderCards();
      this.renderGrid();
    }

    renderCards() {
      let html = '<div class="cp-prd-card-none"></div>';
      const container = this.container.querySelector('.main-compare-product');
      if(!container) return
      this.filterProducts.forEach((item, index) => {
        if(!item) return; // 防止空数据
        // html += `
        //   <div class="cp-prd-card cp-prd-card_${index}">
        //       <div class="cp-images">
        //           <img src="${item.image}" alt="${item.title}">
        //       </div>
        //       <div class="cp-title">${item.title}</div>
        //       <div class="cp-desc">${item.desc || ''}</div>
        //       <div class="cp-price">
        //           <span class="cp-price-now">${item.price}</span>
        //           <span class="cp-price-origin">${item.compare_at_price}</span>
        //       </div>
        //       <div class="cp-buy-btn"><a href="${item.url}" target="_blank">Buy Now</a></div>
        //   </div>`;
        html += `
          <div class="cp-prd-card cp-prd-card_${index}">
              <a class="cp-images" href="${item.url}">
                  <img src="${item.image}" alt="${item.title}">
                  ${item.image_icon ? `<img src="${item.image_icon}" alt="${item.title}" class="cp-images-icon">` : ''}
              </a>
          </div>`;
      });
      container.innerHTML = html;
    }

    renderGrid() {
      this.filterProducts.forEach((item, index) => {
        if(!item) return;
        this.specKeys.forEach(key => {
          // 注意：这里使用 container.querySelector 防止 ID 冲突 (尽管ID理应唯一)
          // 为了安全，建议把 ID 选择器改成 class 选择器，或者确保页面唯一
          // 这里沿用你的 ID 写法：
          const cell = this.container.querySelector(`#grid-${key}-${index}`);
          if (cell) {
            if (item.metafields && item.metafields[key] !== undefined) {
              let v = item.metafields[key];
              cell.textContent = typeof v === 'boolean' ? (v ? '✓' : '/') : v;
            } else {
              cell.textContent = '/';
            }
          }
        });
      });
    }
  }
  // 暴露全局初始化函数 (供 AJAX 调用)
  window.initProductCompareModal = function(sectionElement) {
      new ProductCompareModal(sectionElement);
  };
})()